var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArr4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 21,
    viewBox: "0 0 35 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 20H29C31.7614 20 34 17.7614 34 15V1H6C3.23858 1 1 3.23858 1 6V20Z",
    stroke: "#E85446",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2344 10.064L24.9544 6V7.872L20.7784 10.464L24.9544 12.992V14.944L18.2344 10.944V10.064Z",
    fill: "#E85446"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0469 10.064L16.7669 6V7.872L12.5909 10.464L16.7669 12.992V14.944L10.0469 10.944V10.064Z",
    fill: "#E85446"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArr4);
export default __webpack_public_path__ + "static/media/arr4.152b4ec1757cbe17acd84ee1c96536cc.svg";
export { ForwardRef as ReactComponent };